// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1_2-f","selected":"Chip_selected__3XQ8P"};